import React from 'react';
import useViewport from 'utils/useViewportHelper';
import RenderLink from 'components/RenderLink';
import { ROOT } from 'constants/routeConstants';
import logo from 'assets/images/logo/journey-logo.png';
import styles from './Header.module.scss';

interface Props {
  telNo?: string;
}

const Header = ({ telNo }: Props) => (
  <>
    <nav className={`${styles.container}`}>
      <RenderLink url={ROOT}>
        <img className={styles.logo} src={logo} alt="RAC Logo" />
      </RenderLink>
      <div className={styles.navItems}>
        <b>Call</b>&nbsp;
        {useViewport().isMobile
          ? (<a href={`tel:+44${telNo && telNo.replace(/\s/g, '')}`} className={styles.telephoneNo}>{telNo}</a>)
          : (<span className={styles.telephoneNo}>{telNo}</span>)}
      </div>
    </nav>
    <div className={styles.shadow} />
  </>
);

export default Header;
